import { render, staticRenderFns } from "./NotesDetailModal.vue?vue&type=template&id=e35c01e0&"
import script from "./NotesDetailModal.vue?vue&type=script&lang=js&"
export * from "./NotesDetailModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports